import { render, staticRenderFns } from "./AvatarControl.vue?vue&type=template&id=2baddedb&scoped=true"
import script from "./AvatarControl.vue?vue&type=script&lang=js"
export * from "./AvatarControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baddedb",
  null
  
)

export default component.exports